export default __webpack_public_path__ + "static/media/mail 1.7a25374c.svg";